import React, { useEffect, useRef } from 'react';
import { getWeekIntervalStrings } from '@amzn/atoz-shiftapp-utilities';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { View } from '@amzn/atoz-web/View';
import { Row } from '@amzn/atoz-web/Row';
import { NUMBER_OF_WEEKS } from './LocationEligibilityTabsTypes';
var scrollToRef = function (ref) {
    var _a;
    return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'end'
    });
};
var isKeyRight = function (key) {
    return key === 'ArrowRight' || key === 'Right' || key === 'ArrowDown';
};
var isKeyLeft = function (key) {
    return key === 'ArrowLeft' || key === 'Left' || key === 'ArrowUp';
};
var setTabDeselected = function (tab) {
    var _a, _b;
    (_a = tab.current) === null || _a === void 0 ? void 0 : _a.setAttribute('tabindex', '-1');
    (_b = tab.current) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-selected', 'false');
};
export var LocationEligibilityTabs = function (_a) {
    var selectedWeek = _a.selectedWeek, setSelectedWeek = _a.setSelectedWeek;
    var weekIntervals = getWeekIntervalStrings(NUMBER_OF_WEEKS);
    var tabList = useRef(null);
    var tabs = new Array();
    for (var i = 0; i < weekIntervals.length; i++) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tabs[i] = useRef(null);
    }
    var selectedTabIndex = selectedWeek - 1;
    useEffect(function () {
        var _a, _b, _c;
        for (var _i = 0, tabs_1 = tabs; _i < tabs_1.length; _i++) {
            var tab = tabs_1[_i];
            (_a = tab.current) === null || _a === void 0 ? void 0 : _a.setAttribute('tabindex', '-1');
        }
        // Set tab as selected
        (_b = tabs[selectedTabIndex].current) === null || _b === void 0 ? void 0 : _b.setAttribute('tabindex', '0');
        (_c = tabs[selectedTabIndex].current) === null || _c === void 0 ? void 0 : _c.focus();
        if (selectedWeek === 3) {
            scrollToRef(tabs[tabs.length - 1]);
            return;
        }
        else if (selectedWeek === 2) {
            scrollToRef(tabs[0]);
            return;
        }
    }, [selectedWeek]);
    var onKeyDown = function (e) {
        if (isKeyRight(e.key) && selectedWeek < tabs.length) {
            e.preventDefault();
            setTabDeselected(tabs[selectedTabIndex]);
            setSelectedWeek(selectedWeek + 1);
        }
        else if (isKeyLeft(e.key) && selectedWeek > 1) {
            e.preventDefault();
            setTabDeselected(tabs[selectedTabIndex]);
            setSelectedWeek(selectedWeek - 1);
        }
    };
    return (React.createElement(TabContainer, { ref: tabList, gridGap: "S300" }, weekIntervals.map(function (weekInterval, i) { return (React.createElement(WeekTab, { key: weekInterval, role: "tab", ref: tabs[i], "data-testid": "weekTab-".concat(i), "aria-selected": selectedWeek === i + 1, isSelected: selectedWeek === i + 1, onKeyDown: onKeyDown, onClick: function () { return setSelectedWeek(i + 1); } }, weekInterval)); })));
};
var TabContainer = styledWithTheme(Row)(function (_a) {
    var selectors = _a.theme.selectors;
    return "\n        margin: 0 auto;\n        max-width: 1140px;\n        padding: ".concat(selectors.space('S300'), "px ").concat(selectors.space('S400'), "px;\n    ");
});
var WeekTab = styledWithTheme(View)(function (_a) {
    var selectors = _a.theme.selectors, isSelected = _a.isSelected;
    return "\n        cursor: pointer;\n        background-color: ".concat(isSelected
        ? selectors.color('neutral100')
        : selectors.color('neutral0'), ";\n\n        color: ").concat(isSelected
        ? selectors.color('neutral0')
        : selectors.color('neutral100'), ";\n\n        font-size: ").concat(selectors.fontSize('T200'), ";\n        font-weight: ").concat(selectors.fontWeight('medium'), ";\n        line-height: ").concat(selectors.lineHeight('T200'), ";\n        padding: ").concat(selectors.space('S200'), "px ").concat(selectors.space('S400'), "px;\n        border: 2px solid ").concat(selectors.color('neutral70'), ";\n    ");
});
